import React from 'react';
import cn from 'classnames';
import style from './brands.mod.scss';
import Container from '../layout/container/container';
import Ticker from 'react-ticker';
import { GatsbyImage } from 'gatsby-plugin-image';

const Brands = ({ items, id }) => {
  const classes = cn(style.brands);

  return (
    <Container size="xl">
      <div className={classes}>
          {items.map((item, index) => (
            <div className={style.brands__logo} key={index}>
              <img src={item.logo.url} alt={item.logo.alt} />
            </div>
          ))}
      </div>
      <div className={style.brands__mobile}>
        <Ticker speed={10}>
          {({ index }) => (
            <div className={style.brands__ticker__items}>
              {items.map((item, index) => (
                <div
                  className={style.brands__logo}
                  key={`ticker-item-${item.id}-${index}`}
                >
                  <img src={item.logo.url} alt={item.logo.alt} />
                </div>
              ))}
            </div>
          )}
        </Ticker>
      </div>
    </Container>
  );
};

export default Brands;
